import { createFileRoute } from '@tanstack/react-router';

import { RevenueAccountView } from '@apps/web/components/admin/revenue/revenue_account_view';

export const Route = createFileRoute('/_app/admin/revenue/$account-id')({
    head: () => ({ meta: [{ title: 'Revenue Account | Phoebe Admin' }] }),
    component: RevenueAccountPage,
});

function RevenueAccountPage() {
    const { 'account-id': accountId } = Route.useParams();
    return <RevenueAccountView contractId={accountId} />;
}
